import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export const useTrackClickedShareALink = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedShareALink = useCallback(() => {
    track(`Clicked "Share a link"`);
  }, [track]);

  return { trackClickedShareALink };
};
